import api from './api';
import types from './mutation-types';

export default {
	/**commit mutations*/
	setStateInit_({ commit }) {
		commit(types.STATE_INIT);
	},
	setRowInit_({ commit }) {
		commit(types.ROW_INIT);
	},
	setSearchParam_({ commit }, { key, value }) {
		commit(types.SEARCH_PARAM, { key, value });
	},
	setPagingInfo_({ commit }, { key, value }) {
		commit(types.PAGING_INFO, { key, value });
	},
	setSelectedRow_({ commit }, { key, value }) {
		commit(types.SELECTED_ROW, { key, value });
	},
	setState_({ commit }, { key, value }) {
		commit(types.DEFAULT_ASSIGN, { key, value });
	},

	/**call API */
	async getCommCodes_({ commit, rootState }, { key, codeType }) {
		try {
			const { header, body } = await api.getCommCodes(codeType, rootState['commonStore'].user.plantCd);
			if (header.code === 0) {
				const list = [];
				body.length && body.forEach(row => list.push({ label: row.commCdName, value: row.commCd }));
				await commit(types.DEFAULT_ASSIGN, { key, value: list });
			} else if (header.code === 3) {
			}
			return header;
		} catch (error) {
			return error?.header;
		}
	},
	async getAllCommCodes_({ state, commit, rootState }, { key, codeType }) {
		try {
			const targetArray = state[key];
			const { header, body } = await api.getCommCodes(codeType, rootState['commonStore'].user.plantCd);
			if (header.code === 0) {
				const list = [];
				body.length && body.forEach(row => list.push({ label: row.commCdName, value: row.commCd }));
				await commit(types.DEFAULT_ASSIGN, { key, value: [...targetArray, ...list] });
			} else if (header.code === 3) {
			}
			return header;
		} catch (error) {
			return error?.header;
		}
	},
	async getList_({ commit, state }) {
		try {
			const { searchParams, pagingInfo } = state;
			const data = await api.getList({ searchParams, currentPage: pagingInfo.currentPage, pageUnit: pagingInfo.pageUnit });
			if (data?.header?.code === 0) {
				const { pagingInfo, resultList, fileNames } = data.body;
				commit(types.DEFAULT_ASSIGN, { key: 'pagingInfo', value: pagingInfo });
				commit(types.DEFAULT_ASSIGN, { key: 'resultList', value: resultList });
				commit(types.DEFAULT_ASSIGN, { key: 'fileNames', value: fileNames });
			} else if (data.header.code === 3) {
			}
			return data?.header;
		} catch (error) {
			return error.header || error;
		}
	},
	async getSgrpList_({ state, dispatch }) {
		const { ckuLgrpCd } = state.selectedRow;
		const key = 'sgrpList';
		await dispatch('getCommCodes_', { key, codeType: ckuLgrpCd });
	},
	async getAllSgrpList_({ state, commit }) {
		const codes = state.lgrpList?.map(cd => cd.value)?.join(',');
		const { body } = await api.getMergedCommCodesOnce(codes);
		commit(types.DEFAULT_ASSIGN, { key: 'sgrpAllList', value: body });
	},
	async fileDownload_(store, params = { fileId, fileSeq }) {
		try {
			const response = await api.fileDownload(params);
			const url = window.URL.createObjectURL(new Blob([response.data]));
			const link = document.createElement('a');
			link.href = url;
			const filename = decodeURIComponent(response.headers.filename);
			link.setAttribute('download', filename);
			document.body.appendChild(link);
			link.click();
			link.remove();
			window.URL.revokeObjectURL(url);
		} catch (error) {
			return error?.header;
		}
	},
	async saveData_({ state }, data) {
		try {
			const { lgrpCd, sgrpCd } = state.selectedRow;
			const response = await api.saveData({ lgrpCd, sgrpCd }, data);
			return response;
		} catch (error) {
			return error?.header;
		}
	},
	async toggleUseYnRows_(store, { rows, useYn }) {
		try {
			return await api.toggleUseYnRows(rows, useYn);
		} catch (error) {
			return error?.header;
		}
	},
	//엑셀템플릿 다운
	async excelTempDown_(store, params) {
		try {
			const response = await api.excelTempDown(params);
			const url = window.URL.createObjectURL(new Blob([response.data]));
			const link = document.createElement('a');
			link.href = url;
			const filename = decodeURIComponent(response.headers.filename);
			link.setAttribute('download', filename);
			document.body.appendChild(link);
			link.click();
			link.remove();
			window.URL.revokeObjectURL(url);
		} catch (error) {
			throw new Error(error?.header);
		}
	}
};
